import KudosLogo from '@assets/images/KudosLogo.svg'
import MediaImage from '@components/MediaImage'
import Box from '@mui/material/Box'
import { useT } from '@transifex/react'

const PageKudosTitleImage: React.FC = () => {
  const t = useT()
  return (
    <Box mt={2} height={32}>
      <MediaImage imgSrc={KudosLogo} alt={t('Kudos logo')} backgroundColor=" transparent" eager />
    </Box>
  )
}

export default PageKudosTitleImage
